import _JSXStyle from "styled-jsx/style";
import { useConfig } from '@dhis2/app-runtime';
import PropTypes from 'prop-types';
import React from 'react';
import { useSystemDefaultLocale } from '../utils/useLocale.js';
import { Alerts } from './Alerts.js';
import { ErrorBoundary } from './ErrorBoundary.js';
import { LoadingMask } from './LoadingMask.js';
import { styles } from './styles/AppWrapper.style.js';
export const LoginAppWrapper = _ref => {
  let {
    children
  } = _ref;
  const {
    loading: localeLoading
  } = useSystemDefaultLocale();
  const {
    baseUrl
  } = useConfig();
  // cannot check current user for a loginApp (no api/me)

  if (localeLoading) {
    return /*#__PURE__*/React.createElement(LoadingMask, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `jsx-${styles.__hash}` + " " + "app-shell-adapter"
  }, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: styles.__hash
  }, styles), /*#__PURE__*/React.createElement("div", {
    className: `jsx-${styles.__hash}` + " " + "app-shell-app"
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    onRetry: () => window.location.reload(),
    loginApp: true,
    baseURL: baseUrl
  }, children)), /*#__PURE__*/React.createElement(Alerts, null));
};
LoginAppWrapper.propTypes = {
  children: PropTypes.node
};